export default __webpack_public_path__ + "static/media/etiquette-promo.96df53b2.svg";